export interface PartnerInstitution {
  value: string;
  name: string;
  website: string;
  logo: string;
  logoWidth: number;
  logoHeight: number;
}

export const PARTNER_INSTITUTIONS: PartnerInstitution[] = [
  {
    value: 'university-of-amsterdam',
    name: 'University of Amsterdam',
    website: 'https://www.uva.nl/en',
    logo: 'assets/images/logos/partners/display/university_of_amsterdam.svg',
    logoWidth: 320,
    logoHeight: 70
  },
  {
    value: 'medical-university-of-vienna',
    name: 'Medical University of Vienna',
    website: 'https://www.meduniwien.ac.at/web/en/',
    logo: 'assets/images/logos/partners/display/medical_university_of_vienna.svg',
    logoWidth: 260,
    logoHeight: 88
  },
  {
    value: 'university-of-sao-paulo',
    name: 'University of São Paulo',
    website: 'https://www5.usp.br/',
    logo: 'assets/images/logos/partners/display/university_of_sao_paulo.svg',
    logoWidth: 180,
    logoHeight: 80
  },
  {
    value: 'royal-college-of-surgeons-in-ireland',
    name: 'Royal College of Surgeons in Ireland',
    website: 'https://www.rcsi.com/',
    logo: 'assets/images/logos/partners/display/royal_college_of_surgeons_in_ireland.svg',
    logoWidth: 160,
    logoHeight: 96
  },
  {
    value: 'humanitas-university',
    name: 'Humanitas University',
    website: 'https://www.hunimed.eu/',
    logo: 'assets/images/logos/partners/display/humanitas_university.svg',
    logoWidth: 260,
    logoHeight: 82
  },
  {
    value: 'wroclaw-medical-university',
    name: 'Wroclaw Medical University',
    website: 'https://en.umw.edu.pl/',
    logo: 'assets/images/logos/partners/display/wroclaw_medical_university.svg',
    logoWidth: 270,
    logoHeight: 88
  },
  {
    value: 'stellenbosch-university',
    name: 'Stellenbosch University',
    website: 'https://www.su.ac.za/en',
    logo: 'assets/images/logos/partners/display/stellenbosch_university.svg',
    logoWidth: 180,
    logoHeight: 78
  },
  {
    value: 'university-college-london',
    name: 'University College London',
    website: 'https://www.ucl.ac.uk/',
    logo: 'assets/images/logos/partners/display/university_college_london.svg',
    logoWidth: 180,
    logoHeight: 72
  },
  {
    value: 'university-of-exeter',
    name: 'University of Exeter',
    website: 'https://www.exeter.ac.uk/',
    logo: 'assets/images/logos/partners/display/university_of_exeter.svg',
    logoWidth: 220,
    logoHeight: 84
  },
  {
    value: 'pasteur-network',
    name: 'Pasteur Network',
    website: 'https://pasteur-network.org/',
    logo: 'assets/images/logos/partners/display/pasteur_network.svg',
    logoWidth: 190,
    logoHeight: 74
  },
  {
    value: 'pasteur-institute',
    name: 'Pasteur Institute',
    website: 'https://www.pasteur.fr/en',
    logo: 'assets/images/logos/partners/display/pasteur_institute.svg',
    logoWidth: 180,
    logoHeight: 80
  }
];
